import { brand } from '../colors';

export const muiRadio = {
  defaultProps: {
    color: 'secondary',
  },
  styleOverrides: {
    colorSecondary: {
      '&.Mui-checked': {
        color: brand.vsuite.hover,
      },
    },
  },
};
